import graphql from "babel-plugin-relay/macro"

export const ConversationHistoryCreateChatMutation = graphql`
  mutation ConversationHistoryQuery_createChatMutation (
    $input: CreateChatInput!
  ) {
    createChat(input: $input) {
      clientMutationId
      error {
        message
        code
      }
      chat {
        _id
        messageEvent
        replyToMessageEvent
        createdAt
        deliveredAt
        readAt
        sentAt
        from
        internal
        wUserId
        threadId
        error
        mentions {
          wUserId
          firstName
          lastName
          email {
            email
          }
        }
        agent {
          name
          icon
        }
        user {
          profilePic
          email {
            email
          }
        }
      }
    }
  }
`

export const ConversationHistoryCreateInternalChatMutation = graphql`
  mutation ConversationHistoryQuery_createInternalChatMutation (
    $input: CreateChatInput!
  ) {
    createInternalChat(input: $input) {
      clientMutationId
      error {
        message
        code
      }
      chat {
        _id
        messageEvent
        createdAt
        deliveredAt
        readAt
        sentAt
        from
        internal
        wUserId
        threadId
        error
        mentions {
          wUserId
          firstName
          lastName
          email {
            email
          }
        }
        agent {
          name
          icon
        }
        user {
          profilePic
          email {
            email
          }
        }
      }
    }
  }
`

export const ConversationHistorySignUrlMutation = graphql`
  mutation ConversationHistoryQuery_signUrlMutation ($input: SignUrlInput!) {
   signUrl(input: $input) {
     signUrl
    }
  }
`

export const ConversationHistorySubscription = graphql`
  subscription ConversationHistoryQuerySubscription (
    $threadId: ID!
  ) {
    chat (threadId: $threadId) {
      _id
      messageEvent
      replyToMessageEvent
      createdAt
      deliveredAt
      readAt
      sentAt
      from
      internal
      wUserId
      threadId
      error
      meta
      mentions {
        wUserId
        firstName
        lastName
        email {
          email
        }
      }
      agent {
        name
        icon
      }
      user {
        profilePic
        email {
          email
        }
      }
    }
  }
`

// PLAT-3463. Covers the transitions nobody in this browser clicked - Meta handing
// control back, another agent taking the thread - which a mutation payload cannot.
// NO `updater` is needed: selecting `member { id ... }` lets Relay merge by id into
// the record the mount query populated. Both fields, for the tri-state reason stated
// on the toggle mutation below.
export const ConversationHistoryThreadModeSubscription = graphql`
  subscription ConversationHistoryQueryThreadModeSubscription (
    $wChannelIds: [ID]
    $wMemberId: ID
  ) {
    threadMode (wChannelIds: $wChannelIds, wMemberId: $wMemberId) {
      member {
        id
        liveChat
        activeThreadMode
      }
    }
  }
`

export const ConversationHistoryChatStatusSubscription = graphql`
  subscription ConversationHistoryQueryChatStatusSubscription (
    $threadId: ID!
  ) {
    chatStatus (threadId: $threadId) {
      _id
      messageEvent
      createdAt
      deliveredAt
      readAt
      sentAt
      from
      internal
      wUserId
      threadId
      error
      failedAt
      meta
      agent {
        name
        icon
      }
      user {
        profilePic
        email {
          email
        }
      }
    }
  }
`

export const ConversationHistoryAssignThreadMutation = graphql`
   mutation ConversationHistoryQuery_assignThreadMutation (
    $input: AssignThreadInput!
  ) {
    assignThread(input: $input) {
      clientMutationId
      thread {
        threadId
        folderId
        folder {
          folderId
          name
        }
        member {
          id
          meta
          externalId
          externalProfile
          inboxProfile {
            firstName
            lastName
            profilePicUrl
          }
          liveChat
        }
        wMemberId
        wChannelId
        wChannel {
          name
          integrationIcon
          integrationName
        }
        inputActions {
          integrationIcon
          integrationName
          integrationDescription
          integrationId
          integrationBuild
          iframeContext {
            payload
            signedContext
          }
          contextToken
          customActions {
            url
            body
            headers
            method
            description
            modalSchema
            modalView
            title
            type
          }
        }
        resourceTemplates {
          preview
          alias
        }
        wUserId
        user {
          wUserId
          email {
            email
            verified
          }
          firstName
          lastName
        }
        etag
      }
    }
  }
`

export const ConversationHistoryUpdateThreadFolderMutation = graphql`
   mutation ConversationHistoryQuery_updateThreadFolderMutation (
    $input: UpdateThreadFolderInput!
  ) {
    updateThreadFolder(input: $input) {
      clientMutationId
      thread {
        threadId
        folderId
        folder {
          folderId
          name
        }
        member {
          groupChat
          id
          meta
          externalId
          externalProfile
          inboxProfile {
            firstName
            lastName
            profilePicUrl
          }
          liveChat
        }
        wMemberId
        wChannelId
        wChannel {
          name
          integrationIcon
          integrationName
        }
        inputActions {
          integrationIcon
          integrationName
          integrationDescription
          integrationId
          integrationBuild
          iframeContext {
            payload
            signedContext
          }
          contextToken
          customActions {
            url
            body
            headers
            method
            description
            modalSchema
            modalView
            title
            type
          }
        }
        resourceTemplates {
          preview
          alias
        }
        wUserId
        user {
          wUserId
          email {
            email
            verified
          }
          firstName
          lastName
        }
        etag
      }
    }
  }
`

export const ConversationHistoryToggleMemberLiveChatMutation = graphql`
  mutation ConversationHistoryQuery_toggleMemberLiveChatMutation (
    $input: ToggleMemberLiveChatInput!
  ) {
    toggleMemberLiveChat(input: $input) {
      clientMutationId
      error {
        message
        code
      }
      member {
        id
        meta
        externalId
        externalProfile
        inboxProfile {
          firstName
          lastName
          profilePicUrl
        }
        liveChat
        # PLAT-3371 (d). Mode is a TRI-STATE carried by these two fields, so a
        # payload returning one without the other leaves the store holding half
        # a mode. Relay merges per field, so omitting this would keep a stale
        # value rather than null it out.
        activeThreadMode
      }
    }
  }
`

// PLAT-3371 goal 3. The dispatcher.
//
// `resultingMode` is AUTHORITATIVE and is the only thing the UI may render. The
// `member` selection carries `liveChat` and `activeThreadMode` so Relay's store
// lands on the state the backend actually wrote, rather than on anything derived
// from what was clicked.
export const ConversationHistoryThreadModeUpdateMutation = graphql`
  mutation ConversationHistoryQuery_threadModeUpdateMutation (
    $input: ThreadModeUpdateInput!
  ) {
    threadModeUpdate(input: $input) {
      clientMutationId
      ok
      resultingMode
      changed
      error {
        message
        code
      }
      member {
        id
        meta
        liveChat
        activeThreadMode
      }
    }
  }
`

export const readThreadMutation = graphql`
  mutation ConversationHistoryQuery_readThreadMutation (
    $input: ReadThreadInput!
  ) {
    readThread(input: $input) {
      clientMutationId
      ok
      error {
        message
      }
    }
  }
`

export const unreadThreadMutation = graphql`
  mutation ConversationHistoryQuery_unreadThreadMutation (
    $input: UnreadThreadInput!
  ) {
    unreadThread(input: $input) {
      clientMutationId
      ok
      error {
        message
      }
    }
  }
`
